module.exports = __webpack_public_path__ + "img/ring_y_o_0_1@3x.82c3f823.png";